import urlJoin from 'url-join';
import { APIFeatureDefinition, APIMenuDefinition, APIMenuItem } from '../types';

export function PSCMenuTransformer(resp: APIMenuDefinition): APIMenuDefinition {
  const baseURL = '/password-safe/webconsole';
  return {
    features: resp.features.map((f) => {
      const feature: APIFeatureDefinition = {
        ...f,
        link: f.link != undefined ? (f.link.startsWith('/') ? f.link : urlJoin(baseURL, f.link)) : undefined,
        items:
          f.items?.map((i) => {
            const item: APIMenuItem = {
              name: i.name,
              id: i.id,
              openExternal: i.openExternal,
              tags: i.tags,
              link: i.link.startsWith('/') ? i.link : urlJoin(baseURL, i.link),
            };
            if (i.featureFlag) {
              item.featureFlag = i.featureFlag;
            }
            return item;
          }) ?? undefined,
      };
      if (f.featureFlag) {
        feature.featureFlag = f.featureFlag;
      }
      return feature;
    }),
  };
}
